// src/app/core/config.service.ts
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CONNECTION_OPTION } from "@comunicare/comunicare-interfaces";

@Injectable({ providedIn: "root" })
export class ConfigService {
  private config: {
    apiUrl: string;
    dashboardV2Url: string;
    optionsConnections: CONNECTION_OPTION[];
    simulateIns: boolean;
    serverPrefix: string;
  } | null = null;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    this.config = await this.http
      .get<{ apiUrl: string }>("/assets/config.json")
      .toPromise()
      .then(
        (config) => {
          console.log("ConfigService - load url", config.apiUrl);
          return config;
        },
        (err) => {
          console.error("ConfigService - load failed", err);
          return null;
        }
      );
  }

  get apiUrl(): string {
    return this.config?.apiUrl ?? "http://localhost:8080/api";
  }

  get dashboardV2Url(): string {
    return this.config?.dashboardV2Url ?? "http://localhost:8100";
  }

  get optionsConnections(): CONNECTION_OPTION[] {
    return this.config?.optionsConnections ?? [];
  }

  get simulateIns(): boolean {
    return this.config?.simulateIns ?? false;
  }

  get serverPrefix(): string {
    return this.config?.serverPrefix ?? "002";
  }
}
